import { t } from "../i18n";
import { listExpanded, top5, visibleStations } from "../state";
import { StationCard } from "./StationCard";

export function StationList() {
  const top = top5.value;
  const totalCount = visibleStations.value.length;
  const expanded = listExpanded.value;

  return (
    <div class={`station-list${expanded ? " station-list--expanded" : ""}`}>
      <button
        type="button"
        class="station-list__header"
        aria-expanded={expanded}
        aria-label={expanded ? t("list_collapse") : t("list_expand")}
        onClick={() => {
          listExpanded.value = !expanded;
        }}
      >
        <span>
          {t("list_header")} ({totalCount})
        </span>
        <span class="station-list__chevron" aria-hidden="true">
          {expanded ? "▾" : "▴"}
        </span>
      </button>
      <div class="station-list__items">
        {top.length === 0 && (
          <div class="station-list__empty">{t("list_empty")}</div>
        )}
        {top.map((s, i) => (
          <StationCard key={s.id} station={s} rank={i + 1} />
        ))}
      </div>
    </div>
  );
}
